import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/app/utils/auth.guard';
import { DailyLogDetailComponent } from './daily-log-detail/daily-log-detail.component';
import { DailyLogsComponent } from './daily-logs.component';
import { ViewDailyLogComponent } from './view-daily-log/view-daily-log.component';
// import { SingleDailyLogComponent } from './single-daily-log/single-daily-log.component';
import { DailyLogsPdfComponent } from './daily-logs-pdf/daily-logs-pdf.component';

const routes: Routes = [
  {path:'',component:DailyLogsComponent,canActivate: [AuthGuard]},
  {path:'add',component:ViewDailyLogComponent,canActivate: [AuthGuard]},
  {path:'details',component:DailyLogDetailComponent,canActivate: [AuthGuard]},
  // {path:'single-daily-log',component:SingleDailyLogComponent,canActivate: [AuthGuard]},
  {path:'daily-logs-pdf',component:DailyLogsPdfComponent,canActivate: [AuthGuard]},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DailyLogsRoutingModule { }
